var _defs, _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg122(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500.16 275.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6b9f04;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u043D\u0430 \u0441\u0430\u0439\u0442 \u0423\u041F\u0420") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.36,4.13V212.24a4.13,4.13,0,0,1-4.13,4.13H131.64a4.13,4.13,0,0,1-4.13-4.13V181.83a4.12,4.12,0,0,0-4.13-4.12H93a4.12,4.12,0,0,0-4.13,4.12v30.41a4.13,4.13,0,0,1-4.13,4.13H4.13A4.13,4.13,0,0,1,0,212.24V4.13A4.13,4.13,0,0,1,4.13,0h208.1A4.13,4.13,0,0,1,216.36,4.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234,212.24V4.13A4.13,4.13,0,0,1,238.09,0h80.59a4.13,4.13,0,0,1,4.13,4.13V34.54a4.12,4.12,0,0,0,4.13,4.12h30.4a4.12,4.12,0,0,0,4.13-4.12V4.13A4.13,4.13,0,0,1,365.6,0h80.59a4.13,4.13,0,0,1,4.13,4.13V212.24a4.13,4.13,0,0,1-4.13,4.13H238.09A4.13,4.13,0,0,1,234,212.24Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 450.32,
    y: 225.86,
    width: 49.84,
    height: 49.84,
    rx: 5.32
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg122);
export default __webpack_public_path__ + "static/media/12_2.30eeae884bb72baf8b2c39e42406557c.svg";
export { ForwardRef as ReactComponent };